<?xml version="1.0" encoding="utf-8"?>
<svg
  viewBox="0 0 1024 1024"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M561 821.9v100H449.9v-100c0-12 25-20 55.5-20s55.6 8 55.6 20z"
    fill="#D68231"
  />
  <path
    d="M648.1 921.9c0-10.3-8.4-18.7-18.7-18.7H381.5c-10.3 0-18.7 8.4-18.7 18.7v18.7c0 10.3 8.4 18.7 18.7 18.7h247.9c10.3 0 18.7-8.4 18.7-18.7v-18.7z"
    fill="#218649"
  />
</svg>
